// Checks if a url is a clickout
const isClickOutUrl = url => /^\/x\//i.test(url)
export default isClickOutUrl
